/** Copyright (c) 2022 T. Rowe Price. All rights reserved. */

import './IntradayRefresh.scss';

import { bool, string, object } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import IntradayRefreshLabel from 'components/shared/Intraday/IntradayRefreshLabel';
import IntradayRefreshIcon from 'components/shared/Intraday/IntradayRefreshIcon';
import { getIntradayRefreshStatus } from 'state/account/AccountSelectors';

const IntradayRefresh = ({
  hideLabel = false,
  hideIcon = false,
  containerClassName = '',
  status
}) => {
  const { isIdle } = status;

  if (hideIcon && isIdle) {
    return null;
  }

  return (
    <span className={containerClassName + ' intraday-refresh'}>
      {!hideLabel && <IntradayRefreshLabel />}
      {!hideIcon && <IntradayRefreshIcon />}
    </span>
  );
};

const mapStateToProps = (state) => ({
  status: getIntradayRefreshStatus(state)
});

IntradayRefresh.propTypes = {
  containerClassName: string,
  hideLabel: bool,
  hideIcon: bool,
  status: object
};

export default connect(mapStateToProps)(IntradayRefresh);
